<!-- <div class="wrapper">
    <section class="main-section">
        <router-outlet></router-outlet>
    </section>
</div> -->

<div class="wrapper">
    <section class="main-section">
        <div class="partial">
            <!-- [style.height]="appservice.hideAvatar == true ? '709.5px' : '390px'" -->
            <div class="inner-section content-section content-padding full-h-content"
                [style.width]="appservice.hideAvatar == true ? '100%' : ''">
                <div class="partial logo-section">
                    <ul class="menu">
                        <li [routerLink]="'/bio'" [skipLocationChange]="true">Bio</li>
                        <li [routerLink]="'/pro'" [skipLocationChange]="true">Projects</li>
                        <li [routerLink]="'/cv'" [skipLocationChange]="true">CV</li>
                    </ul>
                    <div class="inner-section logo-section bread" *ngIf="appservice.hideAvatar">
                    </div>
                </div>

                <router-outlet style="display: none;"></router-outlet>
                <div class="social">
                    <app-social-media></app-social-media>
                </div>
            </div>
            <div class="inner-section img-section avatar-section" >
                <picture *ngIf="appservice.isMobile">
                    <source media="(max-width: 1000px)" srcset="../../assets/img/avatar/avatar_mobile.jpeg">
                    <img class="avatar"  alt="avatar">
                </picture>
            </div>
        </div>

    </section>
</div>